import reduxCrud from 'redux-crud';

const accountsReducers = reduxCrud.Map.reducersFor('accounts', { key: '_id' });

export default accountsReducers;
